module.exports = __webpack_public_path__ + "img/reject.f23fe54f.png";